module.exports = __webpack_public_path__ + "static/media/jessen_vidal.ea178108.jpg";